import { useSearchParams } from 'react-router';

const TARGET_SO5_COMPETITION_SEARCH_PARAM = 'targetSo5Competition';

export const withTargetSo5CompetitionSearchParam = (
  path: string,
  targetSo5CompetitionSlug: string | null | undefined
): string => {
  if (!targetSo5CompetitionSlug) return path;

  const searchParams = new URLSearchParams({
    [TARGET_SO5_COMPETITION_SEARCH_PARAM]: targetSo5CompetitionSlug,
  });
  return `${path}?${searchParams.toString()}`;
};

export const useTargetSo5CompetitionSearchParam = (): string | undefined => {
  const [searchParams] = useSearchParams();
  return searchParams.get(TARGET_SO5_COMPETITION_SEARCH_PARAM) ?? undefined;
};
